const PROVINCE_ROWS = [
  ["AB", "Alberta", ["alta"]],
  ["BC", "British Columbia", ["b.c.", "b c"]],
  ["MB", "Manitoba", ["man"]],
  ["NB", "New Brunswick", ["n.b.", "new brunswik"]],
  ["NL", "Newfoundland and Labrador", ["newfoundland", "labrador", "n.l."]],
  ["NS", "Nova Scotia", ["n.s."]],
  ["NT", "Northwest Territories", ["n.w.t.", "nwt"]],
  ["NU", "Nunavut", []],
  ["ON", "Ontario", ["ont"]],
  ["PE", "Prince Edward Island", ["p.e.i.", "pei"]],
  ["QC", "Quebec", ["québec", "pq", "quebec"]],
  ["SK", "Saskatchewan", ["sask"]],
  ["YT", "Yukon", ["y.t."]],
];

const PROV_BY_CODE = Object.fromEntries(
  PROVINCE_ROWS.map(([code, name, aliases]) => [code, { code, name, aliases }])
);

const clean = (v) => String(v || "").trim().toLowerCase();

const buildAliases = (row = {}) => {
  const code = clean(row.code);
  const name = clean(row.name);
  const aliases = (row.aliases || []).map(clean);

  return [code, name, ...aliases, name.replace(/\s+/g, "")]
    .filter(Boolean)
    .filter((v, i, arr) => arr.indexOf(v) === i);
};

const toProv = (input) => {
  const v = clean(input);
  if (!v) return "";

  const hit = PROVINCE_ROWS.find(([code, name, aliases]) => {
    const row = { code, name, aliases };
    return buildAliases(row).includes(v);
  });

  return hit ? hit[0] : "";
};

const provLabel = (code) => {
  const row = PROV_BY_CODE[code];
  if (!row) return code;
  return `${row.code} - ${row.name}`;
};

const provName = (code) => {
  const row = PROV_BY_CODE[code];
  if (!row) return code;
  return row.name;
};

/** All canonical province codes, A–Z by human-readable name (`provName`). */
const getCanonicalProvinceCodesSortedAlphabeticallyByDisplayName = () =>
  [...PROVINCE_ROWS]
    .map(([code]) => code)
    .sort((a, b) => provName(a).localeCompare(provName(b), undefined, { sensitivity: "base" }));

const getProvinceOptionList = (sourceCodes = []) => {
  const uniq = Array.from(new Set(sourceCodes.filter(Boolean)));
  const known = uniq
    .filter((code) => PROV_BY_CODE[code])
    .sort((a, b) => a.localeCompare(b));

  return known.map((code) => ({
    value: code,
    label: provLabel(code),
  }));
};

const buildProvinceQueryClauses = (codes = []) => {
  const list = codes
    .map((code) => PROV_BY_CODE[code])
    .filter(Boolean)
    .map((row) => {
      const set = [row.code, row.name, ...row.aliases];
      const variants = Array.from(
        new Set(
          set
            .filter(Boolean)
            .flatMap((v) => [v, v.toLowerCase(), v.toUpperCase()])
        )
      );
      return {
        province: {
          _in: variants,
        },
      };
    });

  return list;
};

export {
  toProv,
  provLabel,
  provName,
  getCanonicalProvinceCodesSortedAlphabeticallyByDisplayName,
  getProvinceOptionList,
  buildProvinceQueryClauses,
};
